import { render, staticRenderFns } from "./importComp.vue?vue&type=template&id=03b6a3ae"
import script from "./importComp.vue?vue&type=script&lang=js"
export * from "./importComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports